import { API_BASE_URL } from '@mmef/shared/api';

/**
 * Fire-and-forget beacons. Deliberately outside RTK Query: these aren't cached, retried, or read
 * back, and a failed beacon must never surface anywhere near the UI.
 *
 * <p><b>fetch(keepalive), not navigator.sendBeacon.</b> sendBeacon is the usual choice for unload,
 * but it can't perform a CORS preflight — and a JSON body across origins (`:3000` → `:8080`)
 * requires one, so every beacon would fail silently. `keepalive` survives unload the same way and
 * negotiates CORS properly.
 *
 * <p>`credentials: 'omit'`: analytics has no business carrying the session cookie.
 */
const COLLECT_URL = `${API_BASE_URL}/api/analytics/collect`;

interface Beacon {
  viewId: string;
  path?: string;
  referrer?: string;
  durationMs?: number;
}

function send(body: Beacon): void {
  try {
    void fetch(COLLECT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'omit',
      keepalive: true,
      // A failed beacon is not the visitor's problem.
    }).catch(() => undefined);
  } catch {
    /* never let measurement break a page */
  }
}

export function trackView(viewId: string, path: string, referrer: string | undefined): void {
  send({ viewId, path, referrer });
}

export function trackDuration(viewId: string, durationMs: number): void {
  // Zero-length views carry no information and would drag the average down.
  if (durationMs <= 0) return;
  send({ viewId, durationMs });
}
